import { messageQuickActionQueryKeys as e } from "./useMessageQuickActionQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { messageAutomationsApi as n } from "@maat/api-chat";
//#region src/messageQuickActions/useMessageQuickActionsQuery.ts
var r = (r) => t({
	queryKey: e.list(r),
	queryFn: async () => (await n.listQuickActions(r)).items
});
//#endregion
export { r as useMessageQuickActionsQuery };
